import React from 'react';
import { clsx } from 'clsx';

interface ToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  label?: string;
}

const Toggle: React.FC<ToggleProps> = ({ checked, onChange, disabled, label }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={(e) => {
      e.stopPropagation();
      onChange(!checked);
    }}
    className={clsx(
      'relative inline-flex h-[17px] w-[30px] flex-none rounded-full transition-colors',
      checked ? 'bg-success' : 'bg-input',
      disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
    )}
  >
    <span
      className={clsx(
        'absolute top-[2px] left-[2px] h-[13px] w-[13px] rounded-full bg-white shadow transition-transform',
        checked && 'translate-x-[13px]',
      )}
    />
  </button>
);

export default Toggle;
